exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-split[data-v-05d53e12]{height:100%;border:1px solid #dcdee2}.m-split-pane .ivu-tabs[data-v-05d53e12],.m-split-pane[data-v-05d53e12]{height:100%}.m-split-pane .ivu-tabs-content[data-v-05d53e12]{height:calc(100% - 20px)}.ivu-tabs-bar[data-v-05d53e12]{border-bottom:0;margin-bottom:0}.m-tabs-content[data-v-05d53e12]{padding:10px}.align-right[data-v-05d53e12]{text-align:right}.m-font-size-16[data-v-05d53e12]{font-size:16px}.m-label[data-v-05d53e12]{width:100px;text-align:right;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-05d53e12","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pdOutPatient/pdOutPatientIndex/index.vue
// module id = 9MZz
// module chunks = 70 239